module.exports = __webpack_public_path__ + "static/img/comunicado_renovacion.0062b0c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/comunicado_renovacion.jpeg
// module id = HERk
// module chunks = 9